import React, { ReactElement } from "react";

function AppleMailIcon(): ReactElement {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      x="0"
      y="0"
      version="1.1"
      height="100%"
      viewBox="0 0 95 95"
    >
      <g>
        <g>
          <g>
            <linearGradient
              id="Background_13_"
              x1="-67.017"
              x2="-67.017"
              y1="748.266"
              y2="746.767"
              gradientTransform="matrix(60 0 0 -60 4071 44901)"
              gradientUnits="userSpaceOnUse"
            >
              <stop offset="0" stopColor="#1E51EE"></stop>
              <stop offset="1" stopColor="#19E6FF"></stop>
            </linearGradient>
            <path
              fill="url(#Background_13_)"
              d="M63.6 5c9 0 13.5 0 18.4 1.5 5.3 1.9 9.5 6.1 11.4 11.4C95 22.8 95 27.4 95 36.4v27.2c0 9 0 13.5-1.5 18.4-1.9 5.3-6.1 9.5-11.4 11.4C77.2 95 72.6 95 63.6 95H36.4c-9 0-13.5 0-18.4-1.5-5.3-2-9.5-6.1-11.4-11.5C5 77.2 5 72.7 5 63.6V36.4c0-9 0-13.5 1.5-18.4 2-5.3 6.2-9.5 11.5-11.4C22.8 5 27.4 5 36.4 5h27.2z"
            ></path>
            <path
              fill="#fff"
              d="M78.9 69.5c-.1 0-.3.1-.4.1h-57c-.1 0-.3 0-.4-.1l17.8-17.8 3.8 3.9c4.1 4.2 10.6 4.2 14.7 0l3.8-3.9 17.7 17.8zm1.1-1.9V32.3c0-.2 0-.4-.1-.5-.1.2-17.7 18.4-17.7 18.4L80 68v-.4zm-60 .1V32.5c0-.2 0-.4.1-.5.1.2 17.7 18.4 17.7 18.4L20.1 68.1c-.1-.1-.1-.3-.1-.4zm59-37.1L56.3 53.8c-3.5 3.5-9.1 3.5-12.5 0L21.1 30.6c-.1-.1 57.9 0 57.9 0z"
            ></path>
          </g>
        </g>
      </g>
    </svg>
  );
}

export default AppleMailIcon;
